import api from '@pray/shared/utils/api';

import type { EmailHealthDiagnostic } from './getEmailHealthDiagnostic';

export type RefreshEmailHealthParams = {
  orgId: string;
};

export async function refreshEmailHealth({
  orgId,
}: RefreshEmailHealthParams): Promise<EmailHealthDiagnostic> {
  const url = `/web/studio/email-health/${orgId}/refresh`;
  const response = await api.executePostRequest<{ data: EmailHealthDiagnostic }>(url, {});
  return response.data.data;
}
